import React from "react";
import PropTypes from "prop-types";
import Currency from "components/Currency";
import { connect } from "react-redux";
import { getStudentTotalCreditAmount, getStudentSchoolID } from "state/school_money/selectors";
import { isXodActive, getStudentExternalDinnerBalance, doesStudentUseExternalCashless } from "state/school_money/selectors";
import "./StudentCreditBalance.css";

class StudentCreditBalance extends React.Component {

  constructor(props){
      super(props);

      // Set default global class property.
      this.creditAmount = 0;
      this.isCredit = false;
      this.isArrears = false;
      this.balanceLabel = "";
  }

  static propTypes = {
    studentID: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired
  }

  // Set credit information based on internal cashless student.
  setCreditInformation(){

      // Get/Set credit information.
      let creditAmount = Number(this.props.creditAmount);
      this.isCredit = creditAmount > 0;
      this.isArrears = creditAmount < 0;
      this.balanceLabel = this.isArrears ? "Arrears" : "Credit";
      this.creditAmount = <Currency amount={ creditAmount } />;

      // Overwrite with external cashless balance information, if an external cashless student.
      this.setExternalCashlessBalanceInformation();
  }

  // Set balance information based on external cashless student.
  setExternalCashlessBalanceInformation(){

      // Ignore this is not dinner money.
      // We only need external dinner balance for dinner money topups.
      if(this.props.type !== "dinner_money"){ return; }

      // Check is this an external cashless student, no then ignore.
      if( !this.props.isExternalCashlessStudent ){ return; }

      // Get/Set credit information.
      let creditAmount = Number(this.props.externalCashlessBalance);
      this.isCredit = creditAmount > 0;
      this.isArrears = creditAmount < 0;
      this.balanceLabel = "Dinner Balance";
      this.creditAmount = <Currency amount={ creditAmount } />;

      // External cashless catering is inactive show message instead of balance.
      if( !this.props.isExternalCashlessActive ){ this.creditAmount = "Unavailable"; }
  }

  // Create css class string for credit label.
  getCreditLabelClass(){

      // Set class to classNames
      let classNames = [ "student-credit-balance" ];

      // Depending on balance set class to change color.
      switch(true){
          case this.isCredit: classNames.push("student-credit-balance--credit"); break;
          case this.isArrears: classNames.push("student-credit-balance--arrears"); break;
          default: classNames.push("student-credit-balance--neutral"); break;
      }

      // Combine array into string and return.
      return classNames.join(" ");
  }

  render() {

    // Set credit information in class global properties.
    this.setCreditInformation();

    return (
      <div className={this.getCreditLabelClass()}>
        <div className="student-credit-balance__label">
          { this.balanceLabel }
        </div>
        <div className="student-credit-balance__amount">
         { this.creditAmount }
        </div>
      </div>
    );
  }
}

export default connect(
  (state, ownProps) => ({
    creditAmount: getStudentTotalCreditAmount(state, ownProps.studentID, ownProps.type),
    externalCashlessBalance: getStudentExternalDinnerBalance(state, ownProps.studentID),
    isExternalCashlessStudent: doesStudentUseExternalCashless(state, ownProps.studentID),
    isExternalCashlessActive: isXodActive(state, getStudentSchoolID(state, ownProps.studentID))
  })
)(StudentCreditBalance);



// WEBPACK FOOTER //
// ./src/components/school_money/StudentCreditBalance.js